export interface ServicesFilter {
  name?: string;
  serviceTypeId?: string;
  vehicleTypeId?: string;
  commercialBusinessId?: string;
}

export const defaultServicesFilter: ServicesFilter = {
  name: '',
  serviceTypeId: '',
  vehicleTypeId: '',
  commercialBusinessId: '',
};
